export default __webpack_public_path__ + "static/media/zeyuni512.5531c3a1.png";